import React from 'react';

import { rhythm } from '../utils/typography';
import { tagline } from '../config/constants';

class Bio extends React.Component {
  render() {
    return (
      <p
        style={{
          marginBottom: rhythm(2.5),
          fontStyle: 'italic'
        }}
      >
        {tagline}
      </p>
    );
  }
}

export default Bio;



// WEBPACK FOOTER //
// ./src/components/Bio.js